/**
 * Header Component
 *
 * Matches original HTML structure exactly.
 * Contains: logo, main-nav, user-section, settings-menu
 */

import { useState } from 'preact/hooks';
import { isAuthenticated, user, logout } from '@/stores/auth';
import { activeTab, setTab, openLoginPrompt, type Tab } from '@/stores/ui';

export function Header() {
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleAvatarClick = () => {
    setSettingsOpen(!settingsOpen);
  };

  const handleLogout = async () => {
    setSettingsOpen(false);
    await logout();
  };

  const handleNavClick = (e: Event, tab: Tab) => {
    e.preventDefault();
    setTab(tab);
  };

  return (
    <header>
      <div class="logo">
        <a
          href="/"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            display: 'block',
            height: '100%',
            width: '100%',
          }}
        >
          sherit
        </a>
      </div>

      {/* Main navigation in the header - shown when logged in */}
      <nav class="main-nav" style={{ display: isAuthenticated.value ? 'flex' : 'none' }}>
        <ul>
          <li>
            <a
              href="#"
              class={`nav-link ${activeTab.value === 'discover' ? 'active' : ''}`}
              data-tab="discover"
              onClick={(e) => handleNavClick(e, 'discover')}
            >
              Discover
            </a>
          </li>
          <li>
            <a
              href="#"
              class={`nav-link ${activeTab.value === 'submit' ? 'active' : ''}`}
              data-tab="submit"
              onClick={(e) => handleNavClick(e, 'submit')}
            >
              Submit
            </a>
          </li>
          <li style={{ display: 'none' }}>
            <a
              href="#"
              class={`nav-link ${activeTab.value === 'leaderboard' ? 'active' : ''}`}
              data-tab="leaderboard"
              onClick={(e) => handleNavClick(e, 'leaderboard')}
            >
              Leaderboard
            </a>
          </li>
          <li>
            <a
              href="#"
              class={`nav-link ${activeTab.value === 'archives' ? 'active' : ''}`}
              data-tab="archives"
              onClick={(e) => handleNavClick(e, 'archives')}
            >
              Archives
            </a>
          </li>
          <li>
            <a
              href="#"
              class={`nav-link ${activeTab.value === 'pods' ? 'active' : ''}`}
              data-tab="pods"
              onClick={(e) => handleNavClick(e, 'pods')}
            >
              My Pods
            </a>
          </li>
        </ul>
      </nav>

      <div class="user-section">
        {isAuthenticated.value ? (
          <div
            class="user-avatar"
            id="user-avatar"
            title="Click for settings"
            onClick={handleAvatarClick}
          >
            <img
              src={user.value?.avatar || '/api/placeholder/36/36'}
              alt="User avatar"
            />
          </div>
        ) : (
          <div id="login-section">
            <button class="btn btn-primary" id="login-btn" onClick={() => openLoginPrompt()}>
              Sign In
            </button>
          </div>
        )}
      </div>

      {/* Settings dropdown menu */}
      <div
        class="settings-menu"
        id="settings-menu"
        style={{ display: settingsOpen ? 'block' : 'none' }}
      >
        <div class="menu-item" id="view-profile-link">
          View Profile
        </div>
        <div class="menu-item" id="settings-link">
          Settings
        </div>
        <div class="menu-divider"></div>
        <div class="menu-item" id="logout-btn" onClick={handleLogout}>
          Logout
        </div>
      </div>
    </header>
  );
}
